// ---------------------------------------------------------------------------
// Geometria e memória da janela do painel dos pins BCF.
//
// A janela vive DENTRO da área do 3D, arrasta-se pela barra do título,
// nunca sai da área, muda de tamanho pela pega e minimiza-se para uma
// barra. A geometria é a de todas as janelas no 3D
// (`viewer/lib/geometriaDaJanelaNo3D.ts`, que nasceu aqui); este módulo
// só fixa o que é dos pins:
// a chave da memória, o tamanho e o canto onde abre (o inferior esquerdo,
// onde o painel sempre esteve: o canto superior direito é do cubo de
// navegação e a Section box abre por baixo dele).
//
// A chave não entra na recuperação da sessão (`isWorkKey` em
// core/session/recoveryManifest.ts devolve false): é preferência.
// ---------------------------------------------------------------------------

import {
  gravarJanela,
  lerJanela,
  limitarPosicao,
  limitarTamanho as limitarTamanhoNo3D,
  MARGEM,
  posicaoPorOmissao as posicaoNoCanto,
  redimensionar as redimensionarNo3D,
  type EstadoDaJanela,
  type Ponto,
  type Tamanho,
} from '@viewer/lib/geometriaDaJanelaNo3D'

export { limitarPosicao, MARGEM }
export type { Ponto, Tamanho }
export type EstadoJanelaDosPins = EstadoDaJanela

export const CHAVE_JANELA_PINS = 'vn2r.bcfPins.janela'

export const TAMANHO_POR_OMISSAO: Tamanho = { w: 340, h: 560 }
export const TAMANHO_MINIMO: Tamanho = { w: 280, h: 200 }

export function limitarTamanho(t: Tamanho, area: Tamanho): Tamanho {
  return limitarTamanhoNo3D(t, area, TAMANHO_MINIMO)
}

export function redimensionar(t0: Tamanho, delta: Ponto, pos: Ponto, area: Tamanho): Tamanho {
  return redimensionarNo3D(t0, delta, pos, area, TAMANHO_MINIMO)
}

/** Posição por omissão: canto inferior esquerdo, dentro da área. */
export function posicaoPorOmissao(area: Tamanho, janela: Tamanho): Ponto {
  return posicaoNoCanto(area, janela, 'inferior-esquerdo')
}

export function lerJanelaDosPins(storage?: Storage | null): EstadoJanelaDosPins {
  return lerJanela(CHAVE_JANELA_PINS, storage)
}

export function gravarJanelaDosPins(estado: EstadoJanelaDosPins, storage?: Storage | null): void {
  gravarJanela(CHAVE_JANELA_PINS, estado, storage)
}
